import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { YoutubeStatsWaveformGraph as YoutubeStatsWaveformGraphV1 } from './v1/YoutubeWaveformGraph';
import { YoutubeStatsWaveformGraphV2 } from './v2/charts/YoutubeStatsWaveformGraphV2';

/**
 * Selects the waveform overlay implementation according to the YouTube stats API flag.
 */
export function YoutubeStatsWaveformGraph() {
  const useYoutubeStatsV2 = useFeatureIsOn('app__youtube_stats_use_v2_api');
  return useYoutubeStatsV2 ? <YoutubeStatsWaveformGraphV2 /> : <YoutubeStatsWaveformGraphV1 />;
}
